import { http } from "../http/Http";
import { ServiceResponse, GetByFiltersArguments, LogitudeLookupModel } from "../models";

export class LogitudeLookupService{

    private Url : string ; 
    constructor( url: string){
        this.Url = url ; 
    }

    getByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<LogitudeLookupModel[]>> => {
        const { data } = await http.post<ServiceResponse<LogitudeLookupModel[]>>(this.Url+"/GetByFilters", apiQueryFilter);
        return data;
    };

    getById = async (id: number): Promise<LogitudeLookupModel> => {
        const { data } = await http.get<LogitudeLookupModel>((this.Url+"/GetById/" + id?.toString()));
        return data;
    };

    getByExternalId = async (id: string): Promise<LogitudeLookupModel> => {
        const { data } = await http.get<LogitudeLookupModel>((this.Url+"/GetByExternalId/" + id));
        return data;
    };

}